import { ActionType, isAction } from '../../../shared/state/index.state';
import { AdminActions } from './admin.actions';

export const STORE_FEATURE_USER_STATUS = 'availableUserStatuses';

export interface AvailableUserStatusesState {
    statuses: Array<string>;
}

const initialUserStatusesValue = {
    statuses: []
};

export function availableUserStatusesStateReducer(state = initialUserStatusesValue,
                                                  action: ActionType<any>): AvailableUserStatusesState {

    if (isAction(action as ActionType<Array<any>>, AdminActions.GET_AVAILABLE_USER_STATUSES_SUCCESS)) {

        return {
            ...state,
            statuses: (action as ActionType<any>).payload as Array<any>
        };
    } else if (isAction(action as ActionType<Array<any>>, AdminActions.GET_AVAILABLE_USER_STATUSES_FAIL)) {
        return state;
    }

    return state;
}
